<template>
    <div>
        <mu-avatar icon="vertical_align_top"></mu-avatar>
        <label>返回顶部</label>
    </div>
</template>
<script>
export default {
    name: 'backTop'
}
</script>



// WEBPACK FOOTER //
// backTop.vue?5c51d5b0